/**
 * @author Hiroki Moto
 * @description https://marvelapp.com/43fgc52/screen/55967492
 */

import React from 'react';
import PropTypes from 'prop-types';
import * as ProgramsList from '@components/LibraryProgramsList';

function List(props) {
    const { data, role } = props;

    return (
        <>
            <div className="d-flex py-2">
                <div className="d-flex-6 dsl-m12">Certification</div>
                <div className="d-flex-1 dsl-m12">Goals</div>
                <div className="d-flex-1 dsl-m12">Courses</div>
                <div className="d-flex-1 dsl-m12">Assigned</div>
            </div>
            {data.map((item, index) => (
                <ProgramsList.ClosedList
                    key={`${item.id}-${index}`}
                    role={role}
                    name={item.title}
                    description={item.data.description}
                    thumbnail={item.data.thumb_url}
                    modules={item.data.assigned}
                    quotasCount={item.data.quota_count}
                    courseCount={item.data.course_count}
                    type="certifications"
                    published={item.published}
                    onToggle={() => props.onToggle(item.id)}
                    onChange={(e) => props.onChange(e, item)}
                />
            ))}
        </>
    );
}

List.propTypes = {
    role: PropTypes.number,
    data: PropTypes.array,
    onToggle: PropTypes.func,
    onModal: PropTypes.func,
    onChange: PropTypes.func,
};

List.defaultProps = {
    role: 1,
    data: [],
    onToggle: () => {},
    onModal: () => {},
    onChange: (event, program) => {},
};

export default List;
